import { Money as MoneyType } from '../../types/sharetribe/money';
import { Conditions } from '../../shopConfig/filters/condition';
import { FindItemMethod, ListingItemType } from '../../types/sharetribe/listing';
import { ShopifyProductVariant as ShopifyProductVariantType } from '../../types/shopify/product';

export enum ListingFlowFormField {
  Category = 'category',
  Condition = 'condition',
  Quirks = 'quirks',
  Description = 'description',
  Images = 'images',
  NumRequiredImages = 'numRequiredImages',
  OriginalPrice = 'originalPrice',
  Price = 'price',
  ShopifyProduct = 'shopifyProduct',
  ShopifyProductVariant = 'shopifyProductVariant',
  Tags = 'tags',
  Acknowledgement = 'acknowledgement',
  ItemType = 'itemType',
  InternalBrandNotes = 'internalBrandNotes',
  SelectedVariantOptions = 'selectedVariantOptions',
  AllImages = 'allImages',
  OriginatedAsGuestListing = 'originatedAsGuestListing',
  FeaturedImageId = 'featuredImageID',
  FindItem = 'findItem',
  ListingFinishTime = 'listingFinishTime',
  ListingStartTime = 'listingStartTime',
  ListingFlowSectionToTimestamp = 'listingFlowSectionToTimestamp',
  StockPhotos = 'stockPhotos',
  DidUseQRCode = 'didUseQRCode',
  ShopifyProductVariantIdBySku = 'shopifyProductVariantBySku',
  ListingTitle = 'listingTitle',
  RecommendedPrice = 'recommendedPrice',
  AutomaticPriceDropEnabled = 'automaticPriceDropEnabled',
  AutomaticPriceDropPercentage = 'automaticPriceDropPercentage',
  AutomaticPriceDropMinPrice = 'automaticPriceDropMinPrice',
  AutomaticPriceDropAnchorPrice = 'automaticPriceDropAnchorPrice',
  PayoutCreditBoostPromoId = 'payoutCreditBoostPromoId',
}

export interface ItemDetailsFormValues {
  acknowledgement?: string;
  category?: string | null;
  categories?: string[];
  condition?: Conditions;
  description?: string;
  emailOrPhoneForOrder?: string;
  featuredImageID?: string;
  lineItemId?: string;
  orderConfirmationNumber?: string;
  originalPrice?: MoneyType | null;
  price?: MoneyType;
  quirks?: string[];
  shopName?: string;
  shopifyProductVariant?: ShopifyProductVariantType | null;
  tags?: string[] | null;
  userGeneratedTitle?: string;
  selectedVariantOptions?: Record<string, string> | null;
  itemType?: ListingItemType;
  internalBrandNotes?: string;
  // TODO (anniew|TREET-1865) Clean up and type images
  images?: any[];
  numRequiredImages?: number;
  allImages?: any[];
  sharetribeFeaturedImageId?: string;
  findItem?: FindItemMethod;
  listingFinishTime?: number;
  listingFlowSectionToTimestamp?: { [sectionName: string]: number };
  authentication?: string;
  stockPhotos?: string[] | null;
  didUseQRCode?: string;
  listingTitle?: string;
  recommendedPrice?: MoneyType | null;
  automaticPriceDropEnabled?: boolean | null;
  automaticPriceDropMinPrice?: MoneyType | null;
  automaticPriceDropPercentage?: number | null;
  automaticPriceDropAnchorPrice?: MoneyType | null;
  payoutCreditBoostPromoId?: string;
}

export interface ItemDetailsFormState {
  dirty: boolean;
  submitting: boolean;
  errors: { [field in keyof ItemDetailsFormValues]: string };
  values: ItemDetailsFormValues;
}
